var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderTypeParagraphCharacterAllCaps = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9148 4.99805C5.9148 4.7219 5.69094 4.49805 5.4148 4.49805C5.13866 4.49805 4.9148 4.7219 4.9148 4.99805H5.9148ZM4.9148 15.0022C4.9148 15.2784 5.13866 15.5022 5.4148 15.5022C5.69094 15.5022 5.9148 15.2784 5.9148 15.0022H4.9148ZM2.08008 4.49805C1.80394 4.49805 1.58008 4.7219 1.58008 4.99805C1.58008 5.27419 1.80394 5.49805 2.08008 5.49805V4.49805ZM8.74952 5.49805C9.02567 5.49805 9.24952 5.27419 9.24952 4.99805C9.24952 4.7219 9.02567 4.49805 8.74952 4.49805V5.49805ZM4.9148 4.99805V15.0022H5.9148V4.99805H4.9148ZM2.08008 5.49805H8.74952V4.49805H2.08008V5.49805Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0853 4.99805C15.0853 4.7219 14.8615 4.49805 14.5853 4.49805C14.3092 4.49805 14.0853 4.7219 14.0853 4.99805H15.0853ZM14.0853 15.0022C14.0853 15.2784 14.3092 15.5022 14.5853 15.5022C14.8615 15.5022 15.0853 15.2784 15.0853 15.0022H14.0853ZM11.2506 4.49805C10.9745 4.49805 10.7506 4.7219 10.7506 4.99805C10.7506 5.27419 10.9745 5.49805 11.2506 5.49805V4.49805ZM17.9201 5.49805C18.1962 5.49805 18.4201 5.27419 18.4201 4.99805C18.4201 4.7219 18.1962 4.49805 17.9201 4.49805V5.49805ZM14.0853 4.99805V15.0022H15.0853V4.99805H14.0853ZM11.2506 5.49805H17.9201V4.49805H11.2506V5.49805Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderTypeParagraphCharacterAllCaps);
export default ForwardRef;